<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-5">
        <div class="card shadow-sm">
          <div class="card-body p-4">
            <h2 class="card-title text-center mb-1">Nueva contraseña</h2>
            <p class="text-muted text-center mb-4 small">Introduce y confirma tu nueva contraseña</p>

            <div v-if="!token" class="alert alert-danger">
              Enlace de recuperación inválido. Solicita uno nuevo.
            </div>

            <div v-if="exito" class="alert alert-success">
              <i class="bi bi-check-circle me-2"></i>
              Contraseña restablecida correctamente.
              <router-link to="/login" class="alert-link ms-1">Ir al login</router-link>
            </div>

            <div v-if="error" class="alert alert-danger">{{ error }}</div>

            <form v-if="token && !exito" @submit.prevent="handleSubmit">
              <div class="mb-3">
                <label class="form-label">Nueva contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="password"
                  minlength="6"
                  required
                  autofocus
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Confirmar contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': password && confirmPassword && password !== confirmPassword }"
                  v-model="confirmPassword"
                  required
                />
                <div class="invalid-feedback">Las contraseñas no coinciden</div>
              </div>
              <div class="d-grid mb-3">
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="loading || (password && confirmPassword && password !== confirmPassword)"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  {{ loading ? 'Guardando...' : 'Establecer nueva contraseña' }}
                </button>
              </div>
            </form>

            <div class="text-center">
              <router-link to="/login" class="text-muted small">
                <i class="bi bi-arrow-left me-1"></i> Volver al inicio de sesión
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import axios from '../config/axios';

export default {
  name: 'ResetPasswordView',
  setup() {
    const route = useRoute();
    const token = ref('');
    const password = ref('');
    const confirmPassword = ref('');
    const loading = ref(false);
    const exito = ref(false);
    const error = ref('');

    onMounted(() => {
      token.value = route.query.token || '';
    });

    const handleSubmit = async () => {
      if (password.value !== confirmPassword.value) {
        error.value = 'Las contraseñas no coinciden';
        return;
      }
      loading.value = true;
      error.value = '';
      try {
        await axios.post('/api/auth/reset-password', {
          token: token.value,
          password: password.value
        });
        exito.value = true;
      } catch (err) {
        error.value = err.response?.data?.error || 'Error al restablecer la contraseña. El enlace puede haber expirado.';
      } finally {
        loading.value = false;
      }
    };

    return { token, password, confirmPassword, loading, exito, error, handleSubmit };
  }
};
</script>
